import { getLocale } from "../runtime";

const sv_emptycarttext = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Din varukorg är tom.`
};

const emptycarttext = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_emptycarttext(inputs)
	return "emptyCartText";
};

export { emptycarttext as "emptyCartText" };